export const getPositiveOrder = <T>(array: T[], element: T) => {
  const order = array.indexOf(element);
  return order === -1 ? array.length : order;
};
